/**
 * 21/10/2026 — the one line above a route test's ranking: the engine's own
 * ("Ranked by the formula at 09:15 · on its test drops") or the one so far
 * ("So far — 2 of 4 test drops settled"), and the bar when a "Use for the
 * rest of today" rule is set. The time arrives worded (country clock first).
 * For Media Devoted | Created By Ciro Autiero
 */
import type { DropGenRouteTestRanking } from '@trafficpulse/shared';

export const BAR_WORDS = 'a gateway must clear the “Use for the rest of today” rule';

export function rankingHeadline(r: Pick<DropGenRouteTestRanking, 'final' | 'source' | 'gated'>, a: { at: string | null; progress: string }): string {
  const on = r.source === 'gateway' ? "on the gateways' own stats" : 'on its test drops';
  const bar = r.gated ? ` · ${BAR_WORDS}` : '';
  if (!r.final) return `${a.progress} · ${on}${bar}`;
  return a.at ? `Ranked by the formula at ${a.at} · ${on}${bar}` : `Every test drop has settled — the ranking the engine reads · ${on}${bar}`;
}

/** "So far — 2 of 4 test drops settled" / "… sent". */
export const progressWords = (done: number, planned: number, verb: 'settled' | 'sent'): string =>
  planned === 0 ? 'So far — no test drop planned today' : `So far — ${done} of ${planned} test drop${planned === 1 ? '' : 's'} ${verb}`;
